import { Select } from "antd";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import * as R from "ramda";

import Button from "../Button";
import { updateCandidateTags } from "../../store/actions/opportunity";

import styled from "styled-components/macro";

const WrapperButton = styled.div`
  margin-top: 20px;
  display: flex;
  gap: 30px;
  justify-content: ${({ center }) => (center ? "center" : "flex-end")};
`;

const CandidateTags = ({
  opportunityId,
  candidates = [],
  selectedTags = [],
  allTags = [],
  showCancelButton = false,
  onCancel,
  onSave
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [tags, setTags] = useState(selectedTags);
  const isSuperadmin = useSelector(
    R.pipe(
      R.pathOr([], ["user", "roles"]),
      R.includes("headadmin")
    )
  );
  // const isAdmin = useSelector(
  //   R.pipe(
  //     R.pathOr([], ["user", "roles"]),
  //     R.includes("admin")
  //   )
  // );

  const canCreateTags = isSuperadmin;

  // console.log({ opportunityId, candidates, selectedTags, allTags });

  const handleSave = async () => {
    const addTags = R.difference(tags, selectedTags);
    const removeTags = R.difference(selectedTags, tags);
    // console.log({ selectedTags, addTags, removeTags });
    if (!R.isEmpty(addTags) || !R.isEmpty(removeTags)) {
      const payload = { opportunityId, candidates, addTags, removeTags };
      await dispatch(updateCandidateTags(payload));
      if (onSave) onSave(R.assoc("tags", tags, payload));
    }
    if (showCancelButton && onCancel) onCancel();
  };

  return (
    <>
      <Select
        data-test="tags-select"
        mode={canCreateTags ? "tags" : "multiple"}
        value={tags}
        onChange={setTags}
        notFoundContent={""}
        style={{ width: "100%" }}
      >
        {allTags.map(value => (
          <Select.Option key={value} value={value}>
            {value}
          </Select.Option>
        ))}
      </Select>
      <WrapperButton center={showCancelButton}>
        {showCancelButton && (
          <Button onClick={onCancel} type="quaternary">
            {t("global:cancel")}
          </Button>
        )}
        <Button
          onClick={handleSave}
          type="primary"
          disabled={R.equals(tags, selectedTags)}
        >
          {t("global:save")}
        </Button>
      </WrapperButton>
    </>
  );
};

export default CandidateTags;
